import { render } from "./Title.vue?vue&type=template&id=40bf7ddb&ts=true"
import script from "./Title.vue?vue&type=script&lang=ts"
export * from "./Title.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__